import { EditOutlined, SettingOutlined } from '@ant-design/icons';
import { Badge, Button } from 'antd';

import type { DayRoomAccessFormValue } from 'app/utils/dayRoomAccess';

import styles from './DayRoomAccessModal.module.scss';

type Props = {
  value: DayRoomAccessFormValue | null;
  disabled: boolean;
  onClick: () => void;
};

export const DayRoomAccessButton = ({ value, disabled, onClick }: Props) => (
  <Button disabled={disabled} onClick={onClick} className={styles.button}>
    <Badge status={value ? 'success' : 'error'} />
    <span>
      {value ? (
        <>
          Day access <strong>•</strong> {value.durationHours}h
        </>
      ) : (
        'Set up day access'
      )}
    </span>
    {value ? <EditOutlined /> : <SettingOutlined />}
  </Button>
);
